<div class="tw-relative tw-grid tw-grid-cols-3 tw-w-full tw-bg-dt-surface-page tw-rounded-2xl">
  <!-- Sliding background indicator -->
  <div
    class="tw-absolute tw-inset-y-0 tw-w-1/3 tw-bg-color-accent-future-bg border-gradient-path-tabs tw-shadow-elevation-card tw-rounded-2xl tw-transition-transform tw-duration-300 tw-ease-in-out tw-pointer-events-none"
    [style.transform]="'translateX(' + getSelectedTabIndex() * 100 + '%)'"
  ></div>

  @for (option of options; track option.value; let i = $index) {
    <!-- path-tab*: a narrow tab tightens and puts the currency under the amount; see
         path-tabs.component.scss. Which form of the amount shows is measured (app-large-amount). -->
    <div
      class="path-tab tw-relative tw-flex tw-flex-col tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-2xl tw-z-10"
      (click)="onTabChange(option.value)"
      [attr.data-testid]="'path-tab-' + (i + 1)"
    >
      <div
        class="path-tab__body tw-flex tw-gap-3 tw-text-center tw-items-center tw-justify-center tw-text-[14px]"
      >
        <!-- min-w-0 down to the badge, so app-large-amount is handed the room the tab really has
             instead of its full amount's width. -->
        <div class="tw-min-w-0">
          <div
            class="tw-whitespace-nowrap tw-flex tw-justify-center tw-items-center tw-gap-1"
            [ngClass]="{
              'tw-font-medium': isSelectedTab(option.value),
              'tw-font-normal': !isSelectedTab(option.value),
            }"
          >
            {{ option.label }}
            <!-- Small screen expand indicator -->
            @if (isSelectedTab(option.value)) {
              <icon
                class="tw-hidden sm:tw-block"
                [name]="helperExpand.icon"
                [size]="4"
                [currentColor]="'color-text-secondary'"
              ></icon>
            }
          </div>
          @let badge = amountBadge(option.index);
          @if (badge) {
            <!-- The full amounts whenever every tab's fits, else every tab's compact one (-$2.00B),
                 so tabs never mix the two: each app-large-amount measures its own and reports it
                 (fullFits); compactAll forces the rest. Screen readers and the hover title always
                 get the full amount. -->
            <div
              class="path-tab__badge tw-min-w-0 tw-rounded-lg tw-flex tw-gap-1 path-tab-amount-badge tw-whitespace-nowrap tw-py-1 tw-px-2 tw-text-center tw-items-center"
              [ngClass]="{ 'path-tab-amount-badge-selected': isSelectedTab(option.value) }"
              [attr.title]="badge.label"
            >
              <span class="tw-sr-only">{{ badge.label }}</span>
              <app-large-amount
                aria-hidden="true"
                [fullText]="badge.full"
                [compactText]="badge.compact"
                [forceCompact]="compactAll()"
                (fullFits)="setFullFits(i, $event)"
                textClass="tw-text-[14px]"
              ></app-large-amount>
              <span
                class="tw-shrink-0 tw-text-[12px] tw-text-color-text-secondary"
                aria-hidden="true"
                >{{ currency }}</span
              >
            </div>
          }
        </div>
        @if (isSelectedTab(option.value)) {
          <div
            class="path-tab__expand tw-shrink-0 tw-bg-color-surface-elevated tw-rounded-xl tw-shadow-elevation-control tw-px-1 tw-py-3 sm:tw-hidden"
          >
            <icon
              class="tw-cursor-pointer"
              [name]="helperExpand.icon"
              [size]="6"
              [currentColor]="'color-text-secondary'"
              (click)="handleExpand($event)"
            ></icon>
          </div>
        }
      </div>
    </div>
  }
</div>
